<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <div class="dialog-header">
      <fa-icon [icon]="['fas', 'newspaper']"></fa-icon>
      <h2 ngpDialogTitle>{{ dialogTitle }}</h2>
      @if (breadcrumbItems.length) {
        <nav class="preview-breadcrumb" aria-label="breadcrumb">
          <ol class="breadcrumb">
            @for (
              item of breadcrumbItems;
              track item.label;
              let first = $first
            ) {
              <li class="breadcrumb-item" [ngClass]="item.className">
                @if (!first) {
                  <span class="separator">
                    <fa-icon
                      [icon]="
                        item.className?.includes('dimension')
                          ? ['fas', 'link']
                          : ['fas', 'angle-right']
                      "
                      [transform]="
                        item.className?.includes('dimension')
                          ? { rotate: 25 }
                          : undefined
                      "
                    ></fa-icon>
                  </span>
                }
                <span class="breadcrumb-item-link">
                  @if (item.icon) {
                    <span class="icon">
                      <fa-icon [icon]="item.icon"></fa-icon>
                    </span>
                  }
                  <span class="label">{{ item.label }}</span>
                </span>
              </li>
            }
          </ol>
        </nav>
      }
    </div>
    <sui-button
      size="sm"
      variant="danger"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="closeDialog()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <div class="card-tools">
      <sui-toolbar>
        <sui-button
          variant="ghost"
          [leadingIcon]="['fas', 'eye']"
          [trailingIcon]="['fas', 'caret-down']"
          [suiTooltip]="'feed-actions.button.view-tooltip' | translate"
          [suiPopoverTrigger]="viewPanel"
          suiPopoverPlacement="bottom-end"
          [suiPopoverContainer]="'.sui-dialog-simple__content'"
          #viewTrigger="suiPopoverTrigger"
          [expanded]="viewTrigger.isOpen()"
        >
          {{ "feed-actions.button.view" | translate }}
        </sui-button>

        <ng-template #viewPanel>
          <div suiPopover class="dropdown-menu view-panel">
            @for (item of viewMenuItems; track $index) {
              @if (item.isSeparator) {
                <div class="dropdown-divider"></div>
              } @else if (item.isTitle) {
                <div class="dropdown-heading">
                  @if (item.icon) {
                    <fa-icon [icon]="item.icon"></fa-icon>
                  }
                  <span>{{ item.text }}</span>
                </div>
              } @else {
                <a
                  class="dropdown-item"
                  (click)="
                    item.action?.();
                    $event.preventDefault();
                    $event.stopPropagation()
                  "
                >
                  <span class="dropdown-item-link-col1">
                    <span class="dropdown-item-link-label">
                      @if (item.icon) {
                        <div><fa-icon [icon]="item.icon"></fa-icon></div>
                      }
                      <span>{{ item.text }}</span>
                    </span>
                  </span>

                  <span class="dropdown-item-link-col2">
                    @if (item.isToggle) {
                      <input type="checkbox" [checked]="item.isSelected" />
                    }
                    @if (item.isRadio) {
                      <input
                        type="radio"
                        [value]="item.value"
                        [(ngModel)]="viewValues[item.radioGroup || 'time']"
                        [name]="item.radioGroup || 'time'"
                        (change)="item.action?.()"
                        (click)="$event.stopPropagation()"
                      />
                    }
                  </span>
                </a>
              }
            }
          </div>
        </ng-template>
      </sui-toolbar>
    </div>
    <div class="tools">
      <div class="pagination-tools">
        <div class="items-per-page">
          <sui-select
            [ngModel]="itemsPerPage"
            (ngModelChange)="onItemsPerPageChange($event)"
            [dropdownContainer]="'.sui-dialog-simple__content'"
          >
            @for (option of itemsPerPageOptions; track option) {
              <sui-select-option [value]="option">{{
                option
              }}</sui-select-option>
            }
          </sui-select>

          <div class="total-count">
            {{ "feed-results-preview.from" | translate }}
            <span class="bold">{{ totalItemsCount | number }}</span>
            {{ "feed-results-preview.total" | translate }}
          </div>
        </div>
        <div class="pagination-holder">
          <sui-pagination
            [pageSize]="itemsPerPage"
            [currentPage]="currentPage"
            [collectionSize]="totalItemsCount"
            (pageChanged)="onPageChanged($event)"
            (doPageChange)="onPageChanged(+$event)"
          ></sui-pagination>
        </div>
      </div>
    </div>
    @if (postsLoading) {
      <div class="fa-center">
        <fa-icon
          [icon]="['fas', 'spinner']"
          size="3x"
          animation="spin-pulse"
        ></fa-icon>
      </div>
    }

    @if (!postsLoading) {
      <div class="posts-preview-container">
        @if (posts.length === 0) {
          <div class="no-posts-message">
            {{ "feed-results-preview.no-posts" | translate }}
          </div>
        }

        @for (post of posts; track post.id) {
          <app-post-card
            [post]="post"
            [user]="user"
            [selectable]="false"
            [timeShown]="timeShown"
            [viewConfig]="viewConfig"
          ></app-post-card>
        }
      </div>
    }
  </ng-template>

  <ng-template suiDialogFooter>
    <div class="footer-wrapper">
      @for (button of buttons; track button.text) {
        <sui-button
          [variant]="button.variant || 'secondary'"
          [leadingIcon]="button.leadingIcon"
          [disabled]="button.disabled"
          [loading]="button.loading"
          (click)="button.action()"
        >
          {{ button.text }}
        </sui-button>
      }
    </div>
  </ng-template>
</sui-dialog-simple>
